{
  "title": "Mag-book ng pasilidad",
  "lead": "Mga court, gym at bulwagan na maaaring hiramin sa LGU. Tingnan kung kailan bakante at magpadala ng booking request.",
  "empty": "Wala pang pasilidad na bukas para sa booking",
  "emptyBody": "Kapag inilista ng isang opisina ang mga court, gym o bulwagan nito, maaari mo na itong i-book dito.",
  "capacity": "Hanggang {count} katao",
  "needsApproval": "Kailangan ng pag-apruba",
  "instant": "Agad na naka-book",
  "myBookings": "Aking mga booking",
  "noBookings": "Hindi ka pa nakapag-book ng pasilidad.",
  "back": "Lahat ng pasilidad",
  "about": "Tungkol sa pasilidad",
  "where": "Saan",
  "getDirections": "Kumuha ng direksyon",
  "hours": "Oras na maaaring i-book",
  "closed": "Sarado",
  "fees": "Bayad",
  "rules": "Mga patakaran",
  "terms": "Paano mag-book",
  "termNotice": "Mag-book nang hindi bababa sa {count} araw bago ang petsa.",
  "termNoticeOne": "Mag-book nang hindi bababa sa 1 araw bago ang petsa.",
  "termNoticeNone": "Puwedeng mag-book sa mismong araw.",
  "termMax": "Hanggang {hours} oras bawat booking.",
  "termApproval": "Sinusuri ng opisina ang bawat request at ipapaalam sa iyo.",
  "termInstant": "Kung bakante ang oras, kumpirmado agad ang booking mo.",
  "availability": "Kailan bakante",
  "availabilityLead": "Ipinapakita ang mga oras na naka-book at hiniling na. Hindi kailanman ipinapakita ang mga pangalan.",
  "prevWeek": "Nakaraang linggo",
  "nextWeek": "Susunod na linggo",
  "thisWeek": "Ngayong linggo",
  "booked": "Naka-book",
  "requested": "Hiniling",
  "freeAllDay": "Bakante sa oras ng pagbubukas",
  "bookTitle": "Humiling ng booking",
  "signInToBook": "Mag-sign in para i-book ang pasilidad",
  "date": "Petsa",
  "start": "Simula",
  "end": "Tapos",
  "chooseDate": "Pumili muna ng petsa.",
  "closedThatDay": "Sarado sa araw na iyon. Pumili ng ibang petsa.",
  "purpose": "Para saan ito?",
  "purposeHint": "Halimbawa: \"Praktis ng basketball ng kabataan ng barangay\".",
  "participants": "Inaasahang bilang ng tao",
  "participantsHint": "Hanggang {count}.",
  "contactName": "Taong makakausap",
  "contactMobile": "Numero ng mobile",
  "contactHint": "Maaaring tumawag o mag-text ang opisina tungkol sa booking mo.",
  "send": "Ipadala ang booking request",
  "sending": "Ipinapadala…",
  "checkForm": "Pakisuri ang mga naka-highlight na field.",
  "status_pending": "Naghihintay ng pag-apruba",
  "status_approved": "Aprubado",
  "status_declined": "Hindi inaprubahan",
  "status_cancelled": "Kinansela",
  "bookingTitle": "Booking {ref}",
  "bookingLead": "Ipakita ang reference na ito sa pasilidad o sa opisina kung hingin.",
  "pendingNote": "Susuriin ng {office} ang request mo at aabisuhan ka.",
  "approvedNote": "Kumpirmado na ang booking mo.",
  "officeNote": "Paalala mula sa {office}",
  "when": "Kailan",
  "people": "{count} katao",
  "addToCalendar": "Idagdag sa kalendaryo",
  "cancel": "Kanselahin ang booking",
  "cancelTitle": "Kanselahin ang booking na ito?",
  "cancelBody": "Magiging bakante ang oras para sa iba. Puwede kang mag-book ulit kung bakante pa.",
  "cancelYes": "Oo, kanselahin",
  "keep": "Huwag na",
  "cancelled": "Kinansela ang booking mo.",
  "notFound": "Hindi namin makita ang booking na ito.",
  "lastUpdated": "Huling na-update ng {office} noong {date}",
  "staffTitle": "Mga pasilidad",
  "staffLead": "Ang mga court, gym at bulwagan ng opisina ninyo, at ang mga booking request para sa mga ito.",
  "tabBookings": "Mga booking",
  "tabCalendar": "Lingguhang tingin",
  "tabFacilities": "Mga pasilidad",
  "filterPending": "Naghihintay",
  "filterApproved": "Aprubado",
  "filterAll": "Lahat",
  "allFacilities": "Lahat ng pasilidad",
  "facility": "Pasilidad",
  "exportCsv": "I-export ang CSV",
  "noStaffBookings": "Walang booking dito",
  "noStaffBookingsBody": "Dito lalabas ang mga bagong request mula sa mga residente.",
  "conflictWarning": "Sumasabay sa {refs}. Isa lang ang puwedeng aprubahan.",
  "approve": "Aprubahan",
  "decline": "Tanggihan",
  "staffCancel": "Kanselahin ang booking",
  "approveTitle": "Aprubahan ang {ref}?",
  "approveNote": "Paalala sa residente",
  "approveNoteHint": "Opsyonal, hal. kung saan kukunin ang susi.",
  "declineTitle": "Tanggihan ang {ref}?",
  "declineNote": "Dahilan para sa residente",
  "staffCancelTitle": "Kanselahin ang {ref}?",
  "staffCancelNote": "Dahilan para sa residente",
  "noteRequired": "Sabihin sa residente kung bakit.",
  "approvedToast": "Inaprubahan ang booking. Naabisuhan na ang residente.",
  "declinedToast": "Tinanggihan ang booking. Naabisuhan na ang residente.",
  "cancelledToast": "Kinansela ang booking. Naabisuhan na ang residente.",
  "decidedBy": "ni {name}",
  "requestedOn": "Hiniling noong {date}",
  "weekOf": "Linggo ng {date}",
  "noFacilities": "Wala pang pasilidad",
  "noFacilitiesBody": "Idagdag ang mga court, gym o bulwagan ng opisina ninyo para ma-book ito ng mga residente.",
  "addFacility": "Magdagdag ng pasilidad",
  "editFacility": "I-edit ang pasilidad",
  "newFacility": "Bagong pasilidad",
  "inactive": "Nakatago",
  "pendingCount": "{count} naghihintay",
  "upcomingCount": "{count} paparating",
  "readOnly": "Makikita mo ang mga booking. Ang mga editor at pinuno ng opisina ang nag-aapruba at nag-e-edit ng mga pasilidad.",
  "name": "Pangalan",
  "description": "Paglalarawan",
  "location": "Address o lokasyon",
  "pin": "Pin sa mapa",
  "pinHint": "Opsyonal. Nakatutulong para mahanap ito ng mga residente.",
  "barangay": "Barangay",
  "capacityField": "Kapasidad (katao)",
  "photos": "Mga larawan",
  "feesField": "Bayad",
  "feesHint": "Ayon sa ordinansa, hal. \"₱200 bawat oras\". Iwanang blangko kung libre.",
  "rulesField": "Mga patakaran",
  "hoursField": "Oras na maaaring i-book",
  "openDay": "Bukas",
  "opens": "Nagbubukas",
  "closes": "Nagsasara",
  "slotMinutes": "Hakbang ng booking",
  "slotHint": "Nagsisimula at natatapos ang booking sa mga hakbang na ito.",
  "minutes": "{count} minuto",
  "minNotice": "Pinakamaikling abiso (araw)",
  "maxHours": "Pinakamahabang oras bawat booking",
  "requiresApproval": "Suriin muna ang bawat request bago kumpirmahin",
  "requiresApprovalHint": "I-off para agad makumpirma ang mga bakanteng oras.",
  "active": "Ipakita sa mga residente",
  "sort": "Pagkakasunod",
  "save": "I-save ang pasilidad",
  "saved": "Na-save ang pasilidad.",
  "uploading": "Ina-upload ang mga larawan…"
}
